export function NumberValue(input) {
    const number = parseInt(input);
    if (Number.isNaN(number)) {
        return null;
    }
    else {
        return number;
    }
}
export function FloatValue(input, defaultValue = 1) {
    const number = parseFloat(input);
    if (Number.isNaN(number)) {
        return null;
    }
    else {
        return number;
    }
}
export { NumberValue as Number };
export { FloatValue as Float };
//# sourceMappingURL=number.js.map